module.exports = __webpack_public_path__ + "img/007.ad45a895.png";